const buildPeriodFigure = (profitAndLoss, budget) => {
  const variance = profitAndLoss - budget;

  let variancePercent = null;
  if (budget !== 0) {
    variancePercent = (variance / budget) * 100;
  } else if (profitAndLoss !== 0) {
    variancePercent = 100;
  }

  return { profitAndLoss, budget, variance, variancePercent };
};

export const aggregatePeriodFigures = (periods, periodIndexes) => {
  const selected = (periodIndexes || [])
    .map(index => periods?.[index])
    .filter(Boolean);
  if (!selected.length) return null;

  const profitAndLoss = selected.reduce(
    (sum, figure) => sum + (figure.profitAndLoss ?? 0),
    0
  );
  const budget = selected.reduce(
    (sum, figure) => sum + (figure.budget ?? 0),
    0
  );

  return buildPeriodFigure(profitAndLoss, budget);
};

const sumFixedLineShortfall = (row, periodIndexes) =>
  periodIndexes.reduce((shortfall, periodIndex) => {
    const figure = row.periods?.[periodIndex];
    if (!figure) return shortfall;
    const actual = figure.profitAndLoss ?? 0;
    const budget = figure.budget ?? 0;
    return actual < budget ? shortfall + (budget - actual) : shortfall;
  }, 0);

export const aggregateFixedAdjustedPeriodFigures = (
  totalPeriods,
  rows,
  periodIndexes
) => {
  const totalFigure = aggregatePeriodFigures(totalPeriods, periodIndexes);
  if (!totalFigure) return null;

  const fixedShortfall = (rows || [])
    .filter(row => row?.isFixed)
    .reduce(
      (sum, row) => sum + sumFixedLineShortfall(row, periodIndexes || []),
      0
    );

  return buildPeriodFigure(
    totalFigure.profitAndLoss + fixedShortfall,
    totalFigure.budget
  );
};
